// material-ui
import { alpha, Theme } from "@mui/material/styles";

// ==============================|| OVERRIDES - DIALOG ACTIONS ||============================== //

export default function DialogActions(theme: Theme) {
  return {
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2, 3, 3),
          gap: theme.spacing(1.25),
          flexWrap: "wrap",
          justifyContent: "flex-end",
          borderTop: `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
          background: `linear-gradient(180deg, ${alpha(
            theme.palette.primary.light,
            0.04,
          )} 0%, ${alpha(theme.palette.background.paper, 0.92)} 100%)`,
          "& > :not(:first-of-type)": {
            marginLeft: 0,
          },
          "& .MuiButton-root": {
            minWidth: 108,
            paddingInline: theme.spacing(2),
            borderRadius: 12,
            fontWeight: 600,
          },
        },
      },
    },
  };
}
